import React from 'react';
import {Col, Button, Label} from 'react-bootstrap';

import ProductDetail from './ProductDetail';
import UtilHighlightStr from './UtilHighlightStr';

class ProductItem extends React.Component {
   constructor(props) {
      super(props);

      this.handleButtonOpenDetail = this.handleButtonOpenDetail.bind(this);
   }

   /*****************************************/
   /* FUNCTION */
   /*****************************************/
   scrollUpItem(idElement) {
      setTimeout(function() {
         document.getElementById(idElement).scrollIntoView({behavior: "smooth"});
      }, 300);
   }

   returnLabelStyle(check) {
      return (this.props.filterTag === check) ? "success" : "primary"
   }
   returnTextStyle(check) {
      return (this.props.sortInfo[0] === check) ? "text-success" : ""
   }

   /*****************************************/
   /* HANDLE */
   /*****************************************/
   handleButtonOpenDetail() {
      this.props.onBtOpenDetail(this.props.infoItem.id, this.props.ordre)
      this.scrollUpItem(this.props.infoItem.nom)
   }

   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {
      const openPanel = this.props.ordre === this.props.numPanelToOpen && this.props.infoDetail

      const bgImg = {backgroundImage: 'url(' + this.props.infoItem.image + ')'}
      const btStyle = (this.props.infoItem.id === this.props.idItemCliqued) ? "warning" : "info"

      return (
         <div>
            <Col xs={6} sm={4} md={3} lg={2}>
               <div id={this.props.infoItem.nom} className="product-item" style={bgImg}>
                  <div className="info small">
                     <UtilHighlightStr str={this.props.infoItem.nom} filterText={this.props.filterText}/> |
                        <span className={this.returnTextStyle("prix")}> {this.props.infoItem.prix} €</span> |
                           <span className={this.returnTextStyle("poids")}> {this.props.infoItem.poids} kg</span>
                        </div>
                        <Button bsStyle={btStyle} bsSize="large" className="corner0"
                           onClick={this.handleButtonOpenDetail}>
                           <img src="/assets/plus.png" alt="Plus" />
                        </Button>
                        <h5>
                           {this.props.infoItem.tag1 && <Label bsStyle={this.returnLabelStyle('tag1')}>1</Label>}
                           {this.props.infoItem.tag2 && <Label bsStyle={this.returnLabelStyle("tag2")}>2</Label>}
                           {this.props.infoItem.tag3 && <Label bsStyle={this.returnLabelStyle("tag3")}>3</Label>}
                        </h5>
                     </div>
                  </Col>
                  {openPanel &&
                     <ProductDetail
                        infoDetail={this.props.infoDetail} />
                  }
               </div>
            );
         }
      }

      export default ProductItem;



// WEBPACK FOOTER //
// ./src/ProductItem.js